export default "__VITE_ASSET__ddoYFA49__"